// extracted by mini-css-extract-plugin
module.exports = {"root":"TermsOfSale_root__3_mn4","section":"TermsOfSale_section__1vFKn"};